import { Sparkles, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useBooking } from "./BookingDialog";

const LAUNCH_POST_SLUG = "facials-launch-sacramento-esthetician";

// Full-width launch banner that sits above the hero, announcing the arrival
// of facials. Uses the studio's gold-on-navy palette with a subtle sheen.
export default function FacialsLaunchBanner() {
  const { openBooking } = useBooking();

  const scrollToFacials = () => {
    const el = document.getElementById("facials");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div
      data-testid="facials-launch-banner"
      className="relative overflow-hidden bg-gradient-to-r from-[#0F1F4E] via-[#142a66] to-[#0F1F4E] text-[#F8F1D8] border-b border-[#EAD584]/40"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-y-0 -left-24 w-1/3 bg-gradient-to-r from-transparent via-[#EAD584]/25 to-transparent skew-x-12 animate-[shine_5s_ease-in-out_infinite]"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-3 md:py-3.5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
        <span className="inline-flex items-center gap-2 text-[10px] md:text-xs uppercase tracking-[0.3em] text-[#EAD584] font-medium">
          <Sparkles className="w-3.5 h-3.5" /> Just launched
        </span>
        <Link
          to={`/blog/${LAUNCH_POST_SLUG}`}
          data-testid="banner-launch-story-link"
          className="text-sm md:text-base font-light hover:text-[#EAD584] transition-colors"
        >
          Custom facials are here —{" "}
          <span className="font-serif italic text-[#EAD584]">Signature Glow</span>,{" "}
          <span className="font-serif italic text-[#EAD584]">Grand Ritual</span>,{" "}
          <span className="font-serif italic text-[#EAD584]">Renewal Peel</span> &{" "}
          <span className="font-serif italic text-[#EAD584]">Velvet Dermaplane</span>.
          <span className="hidden md:inline text-[#EAD584]/80 ml-1">Read the launch note →</span>
        </Link>
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={scrollToFacials}
            data-testid="banner-see-facials-btn"
            className="text-xs uppercase tracking-wider text-[#EAD584] hover:text-[#F0DC8A] inline-flex items-center gap-1.5"
          >
            See the menu <ArrowRight className="w-3.5 h-3.5" />
          </button>
          <button
            type="button"
            onClick={() => openBooking("The Signature Glow Facial")}
            data-testid="banner-book-facial-btn"
            className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-[#EAD584] text-[#0F1F4E] text-xs uppercase tracking-wider hover:bg-[#F0DC8A] font-medium"
          >
            Book a facial
          </button>
        </div>
      </div>
    </div>
  );
}
